import React from "react";
import { styled } from "styled-components";
import ArrowLeft from "../../icons/ArrowLeft";
import Colors from "../../styles/Colors";
const StyledBackButton = styled.button `
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  border-bottom: 1px solid ${Colors.BLACK};
  color: ${Colors.BLACK};

  svg {
    fill: ${Colors.BLACK};
  }
  &:hover {
    border-bottom: 1px solid transparent;
  }

  &[disabled] {
    cursor: default;
    color: ${Colors.GRAY};
    border-bottom: 0;

    svg {
      fill: ${Colors.GRAY};
    }
  }
`;
const BackButtonContent = styled.span `
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0.25rem;
  font-weight: 300;
  svg {
    position: relative;
    top: -1px;
  }
`;
const BackButtonText = styled.span `
  color: inherit;
  margin-left: 0.75rem;
`;
export const BackButton = React.memo(({ children, title, onClick, disabled }) => (React.createElement(StyledBackButton, { title: title, type: "button", onClick: onClick, disabled: disabled },
    React.createElement(BackButtonContent, null,
        React.createElement(ArrowLeft, { width: 14, height: 14 }),
        React.createElement(BackButtonText, null, children)))));
BackButton.displayName = "BackButton";
export default BackButton;
//# sourceMappingURL=BackButton.js.map